// @flow

import _ from 'lodash';

import googleTagManager from 'google-tag-manager';

import ko from 'rgs-knockout';
import type { Observable, PureComputed } from 'rgs-knockout';

export type AnalyticsOptions = {
	productName: Observable | PureComputed | string,
};

export default class StepsAnalyticsHelper {

	_productName: Observable | PureComputed | string;
	sendOpenStepEvent: (stepId: number, duringWithAllClosed: boolean) => void;

	constructor (options: AnalyticsOptions) {
		this._productName = options.productName;
	}

	sendOpenStepEvent (
		stepID: number,
		duringWithAllClosed: boolean = false,
	): void {
		if (!_.isNil(ko.unwrap(this._productName))
			&& !duringWithAllClosed
			&& !_.isNil(stepID)) {
			
			// RGSSUP-15821 Отправка данным в GA при открытии шагов
			googleTagManager
				.pusher()
				.extend({
					event: 'addEvents',
					eventCategory: ko.unwrap(this._productName),
					eventAction: `step_${stepID}`,
					eventLabel: 'open',
					nonInteraction: stepID === 1,
				})
				.push();
		}
	}
}
